export const formatPinnedDate = (dateString: string): string => {
  const date = new Date(dateString)
  return date.toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
  })
}

export const truncateContent = (content: string, maxLength = 80): string => {
  if (content.length <= maxLength) return content
  return `${content.slice(0, maxLength).trim()}...`
}
